export const arrayUniq = (value: string[]): string[] => {
  const result: string[] = [];
  const uniqValue = {};
  const len = value.length;
  let resultIndex = 0;
  for (let i = 0; i < len; i++) {
    const element = value[i];
    if (uniqValue[element] !== 1) {
      uniqValue[element] = 1;
      result[resultIndex++] = element; // grab the value then increment j
    }
  }
  return result;
};
